/* eslint-disable no-undef */
import useBaseAPI from './useBaseAPI';

const useNotificationAPI = () => {
  const { client, isLoading } = useBaseAPI();

  const getNotifications = async () => {
    try {
      const response = await client('get', '/v1/web/list/?limit=100', null, {
        baseUrl: process.env.REACT_APP_NOTIFICATION_ENDPOINT,
      });
      return response?.data;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const deleteNotifications = async (payload) => {
    try {
      const response = await client('post', '/v1/web/delete/', payload, {
        baseUrl: process.env.REACT_APP_NOTIFICATION_ENDPOINT,
      });
      return response;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const readNotification = async (payload) => {
    try {
      const response = await client('post', '/v1/web/read/', payload, {
        baseUrl: process.env.REACT_APP_NOTIFICATION_ENDPOINT,
      });
      return response;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const sendNotification = async (payload) => {
    try {
      const response = await client('post', '/v1/web/send/', payload, {
        baseUrl: process.env.REACT_APP_NOTIFICATION_ENDPOINT,
      });
      return response;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  return {
    getNotifications,
    deleteNotifications,
    readNotification,
    sendNotification,
    isLoading,
  };
};

export default useNotificationAPI;
